import React, { useEffect } from "react";
import styles from "./sofia.module.css";
import { NavLink, useLocation } from "react-router-dom";

function Sofia({ children }) {
  const location = useLocation();
  useEffect(() => {}, []);
  const atRoot = location.pathname === "/dashboard/sofia";
  return (
    <div className="dashboard-page d-flex">
      <div className={`${styles.sidebarShell} d-flex flex-column`}>
        <nav className={`${styles.sidebarContainer} nav flex-column`}>
           <NavLink
            to="/dashboard/sofia/arg/p"
            className={({ isActive }) =>
              `nav-link ${styles.sidebarLink} ${
                isActive || atRoot ? styles.sidebarLinkActive : ""
              }`
            }
          >
            Sofia ARG Products
          </NavLink>
          <NavLink
            to="/dashboard/sofia/arg/o"
            className={({ isActive }) =>
              `nav-link ${styles.sidebarLink} ${
                isActive ? styles.sidebarLinkActive : ""
              }`
            }
          >
            Sofia ARG Ordenes
          </NavLink>
        </nav>
      </div>
      <div className={`${styles.contentPane} flex-grow-1`}>
        {children}
      </div>
    </div>
  );
}

export default Sofia;
